import { replaceStartDate } from '@utils/date';

import { ROUTES } from './routes';

export const {
  API_GW_URL: BASE_URL,
  S3_ASSETS_URL,
  B2B_PMU_URL: AUTHENTICATION_PMU,
  B2B_COGNITO_URL: AUTHENTICATION_COGNITO,
  API_CATALOG_LINK_URL,
  CGU_LINK_URL,
  PRIVACY_POLICY_LINK_URL,
  FEEDBACK_URL,
} = window.config;

const hdePrefix = '/hde';
const hdePrefixV1 = `${hdePrefix}/v1`;
const b2bPrefix = '/b2b-manager';

export const HDE_ASSETS_URL = `${S3_ASSETS_URL}${hdePrefix}`;
export const SCHEDULE_MEETINGS = `${hdePrefixV1}/schedule/meetings`;
export const SCHEDULE_RACES = `${hdePrefixV1}/schedule/races`;
export const SCHEDULE_RACE_PREVIEW = `${hdePrefix}/schedule/race-preview`;
export const EVENTS = `${hdePrefixV1}/events`;
export const SCHEDULE_RUNNERS = 'runners';
export const ODDS_FINAL = `${hdePrefixV1}/final-dividends`;
export const ODDS_BREAKDOWN = `${hdePrefixV1}/odds/breakdown`;
export const FIXED_ODDS = `${hdePrefix}/fixed-odds`;
const EDITORIAL_CONTENTS = `${hdePrefixV1}/editorial-contents`;
export const POST_RACE_COMMENTS = `${EDITORIAL_CONTENTS}/post-race-comments`;
export const MEETING_TIPS = `${EDITORIAL_CONTENTS}/meeting-tips`;
export const PRESS_BOARD = `${EDITORIAL_CONTENTS}/press-board`;
export const REGIONAL_PRESS_BOARD = `${EDITORIAL_CONTENTS}/regional-press-board`;
export const RACE_TIPS = `${EDITORIAL_CONTENTS}/race-tips`;
export const HORSES = `${hdePrefixV1}/horses`;
export const CONTACTS_USER = `${b2bPrefix}/contacts/user`;
export const CONTACTS_LOGOUT = `${b2bPrefix}/contacts/logout`;
export const CONTACTS_VALIDATE_CGU = `${b2bPrefix}/contacts/validate-cgu`;
export const REFRESH_TOKEN = `${b2bPrefix}/contacts/refresh-token`;
export const PARTNERS = `${b2bPrefix}/partners`;
export const PARTNERS_ISSUE_CERTIFICATE = `${b2bPrefix}/partners/issue-certificate`;
export const CONTACTS_RESEND_CONFIRMATION_EMAIL = `${b2bPrefix}/contacts/resend-confirmation-email`;

const getRaceUrl = ({
  startDate,
  racecourseCode,
  raceNumber,
}: {
  startDate: string;
  racecourseCode?: string;
  raceNumber: number;
}) => `${replaceStartDate(ROUTES.RACECARDS, startDate)}/${racecourseCode}/${raceNumber}`;

const getRacecourseMeetingUrl = ({
  startDate,
  racecourseCode,
}: {
  startDate: string;
  racecourseCode?: string;
}) => {
  return `${replaceStartDate(ROUTES.RACECARDS, startDate)}/${racecourseCode}`;
};

const getRacescardsUrl = ({ startDate }: { startDate: string }) => {
  return replaceStartDate(ROUTES.RACECARDS, startDate);
};

const getQuintePlusUrl = ({ startDate }: { startDate: string }) => {
  return replaceStartDate(ROUTES.QUINTE, startDate);
};

const getNonRunnersUrl = ({ startDate }: { startDate: string }) => {
  return replaceStartDate(ROUTES.NON_RUNNERS, startDate);
};

const getRacingEventsUrl = ({ startDate }: { startDate: string }) => {
  return replaceStartDate(ROUTES.RACING_EVENTS, startDate);
};

const getDashboardUrl = ({ startDate }: { startDate: string }) => {
  return replaceStartDate(ROUTES.DASHBOARD, startDate);
};

const getPublicationsUrl = ({ startDate }: { startDate: string }) => {
  return replaceStartDate(ROUTES.PUBLICATIONS, startDate);
};

export {
  getRacecourseMeetingUrl,
  getRacescardsUrl,
  getRaceUrl,
  getQuintePlusUrl,
  getNonRunnersUrl,
  getRacingEventsUrl,
  getDashboardUrl,
  getPublicationsUrl,
};
